<script>
import {Modal} from "bootstrap"
import Swal from "sweetalert2";
export default {
  data() {
    return {
      configurations: [],
      allawanceLevels: [
        {
          name: "الأجر الإبتدائي",
          name_en: "Basic Salary",
          value: 0,
        },
        {
          name: "علاوة 1",
          name_en: "Allawance Level 1",
          value: 1,
        },
        {
          name: "علاوة 2",
          name_en: "Allawance Level 2",
          value: 2,
        },
        {
          name: "علاوة 3",
          name_en: "Allawance Level 3",
          value: 3,
        },
        {
          name: "علاوة 4",
          name_en: "Allawance Level 4",
          value: 4,
        },
        {
          name: "علاوة 5",
          name_en: "Allawance Level 5",
          value: 5,
        },
        {
          name: "علاوة 6",
          name_en: "Allawance Level 6",
          value: 6,
        },
      ],
      cashAccounts: [],
      emps: [],
      searchModel: "",
      Emps: {},
      selectedTap: true,
      emp_job: [],
      branch: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchEmps: null,
      EmpsSearchMode: false,
      addOptions: [{}],
      editOptions: [{}],
      option: "",
      data: {},
      editModalData: {},
      emp: {
        has_social_insurance:true,
        can_attend:false
      },
      // circlesCounts: 3,
      // currentSteps: 1,
      edit: {},
      branch_id: null,
      add_emp_modal:{},
      edit_emp_modal:{},
      salaryForm : [],
      allsalaries: [],
      // appprices:[],

      project_based: {
        has_salary: false
      },
      submitted: false,
      selectedScheduleType: '',
      hrWorkingScheduleTypes: {},
      configu: {},
      hr_weekdays: [],
      shiftData: {
        weekdays: [
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
          {
            selected: false,
            shifts: [
              {
                start_time: "",
                end_time: "",
              },
            ],
            hr_weekday_id: null,
          },
        ],
        monthdays: Array.from({ length: 31 }, (_, index) => ({
          selected: false,
          shifts: [
            {
              start_time: "",
              end_time: "",
            },
          ],
          hr_month_day_id: index + 1, // Day 1 to 31
        })),
      },
      workDaysPerGroup: null,
      restDays: null,
      workGroups: [
        {
          shifts: Array.from({ length: 1 }, () => [{ start_time: '', end_time: '', day: 1 }]),
          sameAsPrevious: false
        }
      ],
      form:{comboEnable: false, selectedOption:'', accrud: {enabled: false, value: 0}, loan: {enabled: false, value: 0}}
    };
  },
  computed: {
    displayedPages() {
      const totalButtons = 10;
      const half = Math.floor(totalButtons / 2);
      let start = Math.max(1, this.page - half);
      let end = Math.min(this.tot_pages, start + totalButtons - 1);

      // Adjust start if we are near the end of the pagination
      if (end - start < totalButtons - 1) {
        start = Math.max(1, end - totalButtons + 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    progressWidth() {
      return ((this.currentStep - 1) / (this.circlesCount - 1)) * 100 + "%";
    },
    isFirstStep() {
      return this.currentStep === 1;
    },
    isLastStep() {
      return this.currentStep === this.circlesCount;
    },
  },
  methods: {
    editemp(app) {
      this.edit = Object.assign({}, app);
      this.edit.birth_date = this.edit?.birth_date ? this.edit?.birth_date.split("T")[0] : ''
      console.log("???", this.edit);
    },
    editconfigdata(config) {
      console.log(this.editModalData);
      this.editModalData = config;
      console.log("********", config);
      this.config = Object.assign([], config);
    },
    changeStatus(data) {
      console.log(data.target.value)
      if (data.target.value == "on")
        this.edit.has_social_insurance = 1
      else
        this.edit.has_social_insurance = 0

    },
    editconfig() {
      console.log(")))*****", this.addOptions);
      if (this.editModalData.option == "select") {
        this.http
          .post("emps/edit-col", {
            table: "emps",
            options: this.editOptions,
            config: this.editModalData,
            config_id: this.editModalData.id,
          })
          .then(() => {
            this.get(1);
          });
      } else {
        delete this.editModalData.options;
        this.http
          .post("emps/edit-col", {
            table: "emps",
            config: this.editModalData,
            config_id: this.editModalData.id,
          })
          .then(() => {
            this.get(1);
          });
      }
    },
    onChange(event) {
      console.log("_________", event.target.value);
      if (event.target.value == "select") {
        return (this.option = 3);
      }
    },
    addconfig() {
      if (this.data.option == "select") {
        this.http
          .post("emps/add-col", {
            table: "emps",
            data: this.data,
            options: this.addOptions,
          })
          .then(() => {
            this.getconfig(this.page);
          });
      } else {
        console.log("in else");
        console.log(this.data);
        this.http
          .post("emps/add-col", {
            table: "emps",
            data: this.data,
          })
          .then(() => {
            this.data = {};
            this.addOptions = [{}];
            this.getconfig(this.page);
          });
      }
    },
    deleteconfig(config) {
      var data = {
        title: "popups.deletecol",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("table-fileds", config.id).then(() => {
            console.log("############################3");
            this.getconfig(this.page);
          });
        }
      });
    },
    addEmps() {
      console.log("step 166 :",this.emp, this.salaryForm);
      this.submitted = true;
      console.log('validate', this.validateSchedule())
      if (!this.validateSchedule()) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('popups.schedule_required'),
        });
        return;
      }
      console.log('validate two', this.validateEmployeeForm())
      if (!this.validateEmployeeForm() || !this.validateSchedule()) {
        return;
      }
      this.emp.working_schedule_type_id = this.selectedScheduleType.id;
      this.emp.work_days = this.workDaysPerGroup;
      this.emp.rest_days = this.restDays;
      this.http
        .post("emps", {
          data: this.emp,
          types: this.configurations,
          workGroups: this.workGroups,
          shift_data: this.shiftData,
          salaryItems: this.salaryForm,
          schedule_code: this.selectedScheduleType.code,
          form: this.form
        })
        .then(() => {
          
          this.add_emp_modal.hide()

          this.resetData();
          this.get(this.page);
          // this.config = {};
          // this.addOptions = [{}];
        });
    },
    editEmps() {
      console.log(this.edit);
      let data = this.edit;
      console.log(data)
      this.http.put("emps", data.id, data).then(() => {
        this.get(1);
        this.getconfig(1);
        this.edit_emp_modal.hide()
        // this.config = {};
        // this.addOptions = [{}];
      });
    },
    search() {
      if (this.searchModel == "") {
        this.cancelappsearchMode();
        return;
      }
      this.EmpsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("emps/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.emps = res.data;
          this.emps.forEach((emp, index) => {
            let code = (this.page - 1) * this.limit + index + 1;
            emp.code =
              "EMP-" +
              (code < 10
                ? "000" + code
                : code < 100
                  ? "00" + code
                  : code < 1000
                    ? "0" + code
                    : code);
          });
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.EmpsSearchMode = false;
      this.get(this.page);
    },

    getEmps() {
      this.http.get("emps").then((res) => {
        this.emps = res.data;
      })
    },
    deleteEmps(app) {
      var data = {
        title: "popups.deleteemp",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("emps", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },
    getempsjob() {
      this.http.get("emp-job-titles").then((res) => {
        this.emp_job = res.data.map((t) => {
          return { value: t.id, lable: t.name, lable_en: t.name_en };
        });
      });
    },
    getbranch() {
      this.http.get("branches").then((res) => {
        this.branch = res.data.map((t) => {
          return { value: t.id, lable: t.name };
        });
      });
    },
    getEmpsCashAccounts() {
      this.http.post("transactions/cash-accounts", {}).then((res) => {
        this.cashAccounts = res.data;
      });
    },
    get(page) {
      console.log(page);
      this.http
        .post("emps/all-cols", {
          limit: this.limit,
          page: page,
          table: "emps",
          tables: ["emps", "table_fileds", "branches", "emp_job_titles"],
          fields: [
            "emps.*",
            "branches.name as branch_name ",
            "branches.name_en as branch_name_en ",
            "table_fileds.name as name_en",
            "table_fileds.name_ar as name_ar",
            "table_fileds.options as options",
            "emp_job_titles.name as title",
          ],
          where: [
            "table_fileds.table='emps'",
            "emps.branch_id=" + this.branch_id + " ",
            "branches.id=" + this.branch_id + " ",
            "emp_job_titles.id=emps.emp_job_title_id ",
          ],
          relations: [
            {
              table: "emps",
              key: "branch_id",
            },
          ],
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.emps = res.data;
         
          this.emps.forEach((emp, index) => {
           
            emp.has_social_insurance ? emp.has_social_insurance =true :emp.has_social_insurance =false
            emp.can_attend ?emp.can_attend =true : emp.can_attend = false

            let code = (this.page - 1) * this.limit + index + 1;
            emp.code =
              "EMP-" +
              (code < 10
                ? "000" + code
                : code < 100
                  ? "00" + code
                  : code < 1000
                    ? "0" + code
                    : code);
          });
          console.log("%%%%5", this.customers);
        });
    },
    getconfig(page) {
      console.log(page);
      this.http
        .post("emps/get-cols", {
          table: "emps",
        })
        .then((res) => {
          this.configurations = res.data;
          for (let i = 0; i < this.configurations.length; i++) {
            if (this.configurations[i].type == "int") {
              this.configurations[i].type = "number";
            }
            // this.configurations[i].options = JSON.parse(
            //   this.configurations[i].options
            // );
          }
          console.log("//////*******////", this.configurations);
        });
    },
    nextStep() {
      if (this.currentStep < this.circlesCount) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentSteps > 1) {
        this.currentSteps--;
      }
    },
    nextStep_e() {
      if (this.currentSteps < this.circlesCounts) {
        this.currentSteps++;
      }
    },
    getAllSalaries() {
      this.http.get('salary-items/all-salaries').then((res) => {
        this.allsalaries = res.data
      })
    },
    AddSalaryRow() {
      this.salaryForm.push({selectedSalaryItem: null, value: ''})
    },
    isFieldInvalid(field) {
      console.log('aaa', this.submitted, this.emp, !this.emp[field], this.emp[field], this.submitted && !this.emp[field])
      return this.submitted && !this.emp[field];
    },
    validateSchedule() {
      console.log('dfff', this.selectedScheduleType, this.selectedScheduleType.code, typeof this.selectedScheduleType.code)
      if (this.selectedScheduleType.code === 'shift_based') {
        return this.shiftData.weekdays.some(day => day.selected && day.shifts.length > 0);
      }

      if (this.selectedScheduleType.code === 'monthly_days') {
        return this.shiftData.monthdays.some(day => day.selected && day.shifts.length > 0);
      }

      if (this.selectedScheduleType.code === 'work_rest_pattern') {
        return this.workGroups.some(group => group.shifts.length > 0);
      }

      return true;
    },

    validateEmployeeForm() {
      if (!this.emp.name || !this.emp.name_ar || !this.emp.birth_date || !this.emp.emp_job_title_id ||  !this.emp.selected_allawance ||
       !this.emp.cash_account_id || !this.emp.employment_date || !this.emp.tel || !this.emp.degree ||
       !this.emp.tax
      ) {
        console.log('first if')
        Swal.fire({
          icon: 'warning',
          title: this.$t('popups.fill_required_fields'),
        });

        return false;
      }
    
      if (!this.selectedScheduleType || !this.selectedScheduleType.code) {
        console.log('second if')
        Swal.fire({
          icon: 'warning',
          title: this.$t('popups.select_placeholder'),
        });
        return false;
      }

      return true;
    },
    getHrScheduleTypes() {
      this.http.get("emps/hr-working-schedule-types").then((res) => {
        this.hrWorkingScheduleTypes  = res.data;
      });
    },
    getConfigu() {
      this.http.get("emps/config").then((res) => {
        console.log('aaaaaa', res.data)
        this.configu = res.data.reduce((acc, item) => {
          acc[item.name_en] = item.value;
          return acc;
        }, {});
        console.log('sss', this.configu) 
      });
      
    },
    getHrWeekDays() {
      this.http.get("emps/weekdays").then((res) => {
        this.hr_weekdays = res.data;
      });
    },
    initializeDefaultTimes(index) {
      if (this.shiftData.weekdays[index].selected) {
        this.shiftData.weekdays[index].start_time = "07:00"; // Default start time (7 AM)
        this.shiftData.weekdays[index].end_time = "15:00"; // Default end time (3 PM)
      } else {
        this.shiftData.weekdays[index].start_time = ""; // Clear if unchecked
        this.shiftData.weekdays[index].end_time = "";
      }
    },
    resetData() {
      // Reset Group Data
      this.workDaysPerGroup = null,
      this.restDays = null,
      this.workGroups = [
        {
          shifts: Array.from({ length: 1 }, () => [{ start_time: '', end_time: '', day: 1 }]),
          sameAsPrevious: false
        }
      ],

      // Reset weekdays
      this.shiftData.weekdays = Array.from({ length: 7 }, () => ({
        selected: false,
        hr_weekday_id: null,
        shifts: [
          {
            start_time: "",
            end_time: ""
          }
        ]
      }));

      // Reset monthdays (assuming current year and month)
      const year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
      const daysInMonth = new Date(year, month, 0).getDate();

      this.shiftData.monthdays = Array.from({ length: daysInMonth }, (_, i) => ({
        selected: false,
        hr_month_day_id: i + 1,
        shifts: [
          {
            start_time: "",
            end_time: ""
          }
        ]
      }));

      this.project_based = {
        has_salary: false
      }

      this.salaryItems = [
        {
          hr_salary_item_id: null,
          amount: 0,
        },
      ]
    },
    generateMonthDays() {
      const daysInMonth = 31;
      this.shiftData.monthdays = Array.from({ length: daysInMonth }, (_, i) => ({
        selected: false,
        hr_month_day_id: i + 1,
        shifts: [
          {
            start_time: "",
            end_time: ""
          }
        ]
      }));
    },
    addWorkGroup() {
      if (!this.canAddMoreGroups) return;

      const lastGroup = this.workGroups[this.workGroups.length - 1];
      const newGroup = {
        shifts: [],
        sameAsPrevious: false
      };

      const remainingDays = 31 - this.totalDays;
      const daysToAdd = Math.min(this.workDaysPerGroup, remainingDays);

      if (lastGroup.sameAsPrevious) {
        // Clone only up to remainingDays
        newGroup.shifts = lastGroup.shifts.slice(0, daysToAdd).map(dayShifts =>
          dayShifts.map(shift => ({ ...shift }))
        );
      } else {
        // Generate only the remaining number of days
        newGroup.shifts = Array.from({ length: daysToAdd }, (_, i) => [
          {
            start_time: '',
            end_time: '',
            day: i + 1
          }
        ]);
      }

      this.workGroups.push(newGroup);
    },
    totalDays() {
      return this.workGroups.reduce((sum, group) => {
        return sum + group.shifts.length + this.restDays;
      }, 0);
    },
    canAddMoreGroups() {
      return this.totalDays < 31;
    },
    addShift(groupIndex, dayIndex) {
      this.workGroups[groupIndex].shifts[dayIndex].push({
        start_time: '',
        end_time: '',
        day: dayIndex + 1
      });
    },
    removeShift(groupIndex, dayIndex, shiftIndex) {
      const shifts = this.workGroups[groupIndex].shifts[dayIndex];
      if (shifts.length > 1) {
        shifts.splice(shiftIndex, 1);
      }
    },
    deleteGroup(groupIndex) {
      if (this.workGroups.length > 1) {
        this.workGroups.splice(groupIndex, 1);
      }
    },
    updateStepperUI() {
      const progress = document.getElementById("progress");
      const circles = document.querySelectorAll(".circle");
      const content = document.querySelectorAll(".stepper-content");

      if (!this.currentValue || this.currentValue > circles.length) {
        this.currentValue = 1;
      }

      content.forEach((item, index) => {
        item.style.display = index === this.currentValue - 1 ? "block" : "none";
      });

      circles.forEach((circle, index) => {
        circle.classList.toggle("active", index < this.currentValue);
      });

      const actives = document.querySelectorAll(".circle.active");
      console.log('saa', actives)
      progress.style.width =
        ((actives.length - 1) / (circles.length - 1)) * 100 + "%";

      const next = document.getElementById("nextBtn");
      const prev = document.getElementById("prevBtn");
      const submit = document.getElementById("submit");

      submit.style.display = this.currentValue === circles.length ? "block" : "none";
      next.style.display = this.currentValue === circles.length ? "none" : "block";
      next.disabled = this.currentValue === circles.length;
      prev.disabled = this.currentValue <= 1;
    },
    handleSelectChange() {
    // Reset both
    this.form.loan.enabled = false;
    this.form.accrud.enabled = false;

    // Enable the selected one
    if (this.form.selectedOption === 'loan') {
      this.form.loan.enabled = true;
    } else if (this.form.selectedOption === 'accrud') {
      this.form.accrud.enabled = true;
    }
  },
  },
  watch: {
    'project_based.has_salary'() {
      this.$nextTick(() => {
        this.updateStepperUI(); // Recalculate circles and progress
      });
    },
    workDaysPerGroup(newVal) {
      const days = parseInt(newVal);
      this.workGroups.forEach(group => {
        if (group.shifts.length > days) {
          group.shifts.splice(days); // remove extra days
        } else {
          for (let i = group.shifts.length; i < days; i++) {
            group.shifts.push([
              {
                start_time: '',
                end_time: '',
                day: i + 1 // set correct day number
              }
            ]);
          }
        }

        // Also update existing day values
        group.shifts.forEach((dayShifts, i) => {
          dayShifts.forEach(shift => {
            shift.day = i + 1;
          });
        });
      });
    }
  },
  created() {
    let currentUser = JSON.parse(localStorage.currentUser);
    this.branch_id = currentUser.branch_id;
    this.get(1);
    // this.getEmps();
    this.getempsjob();
    this.getHrScheduleTypes();
    this.getconfig();
    this.getHrWeekDays();
    this.getEmpsCashAccounts();
    this.getAllSalaries();
    this.getConfigu()
  },
  mounted() {
    this.add_emp_modal =new Modal('#addemp');
    this.edit_emp_modal= new Modal('#editemps');
    this.generateMonthDays();
    document.getElementById("nextBtn").addEventListener("click", () => {
      this.currentValue = Math.min(this.currentValue + 1, document.querySelectorAll(".circle").length);
      this.updateStepperUI();
      this.generateMonthDays();
    });

    document.getElementById("prevBtn").addEventListener("click", () => {
      this.currentValue = Math.max(this.currentValue - 1, 1);
      this.updateStepperUI();
    });
    this.updateStepperUI();
  },
};
</script>

<template>
  <!--emp tab-->
  <div :dir="$i18n.locale == 'ar' ? 'ltr' : 'ltr'" class="row" v-if="selectedTap">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <div class="search-box chat-search-box w-50">
              <div class="position-relative">
                <input @keyup="search()" type="text" class="form-control fa-lg text-light"
                  :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :placeholder="$t('popups.search')" v-model="searchModel"
                  style="
                    background-color: #2a3042 !important;
                    width: 250px !important;
                  " />
                <i class="bx bx-search-alt search-icon text-light"></i>
              </div>
            </div>
          </div>
          <div class="col-6" style="display: flex; justify-content: flex-end">
            <button class="btn-close text-" v-if="EmpsSearchMode" @click="cancelappsearchMode()"></button>
            <button type="button" @click="selectedTap = !selectedTap" class="btn btn-light float-end mb-4 mx-2">
              <span class="bx bxs-cog float-end fa-2x" style="color: #2a3042 !important"></span>
            </button>
            <button type="button" @click="add_emp_modal.show();emp = {can_attend:false,has_social_insurance:false}" class="btn btn-light float-end mb-4">
              <span class="bx bxs-plus-circle float-end fa-2x" style="color: #2a3042 !important"></span>
            </button>
          </div>
        </div>
        <div class="table-responsive">
          <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            class="table table-centered table-nowrap table-striped table-hover align-middle" v-if="selectedTap">
            <thead>
              <tr class="text-light" style="background-color: #2a3042 !important">
                <th scope="col">#</th>
                <th scope="col">{{ $t("emps.code") }}</th>
                <th scope="col">{{ $t("emps.name") }}</th>
                <th scope="col">{{ $t("emps.designation") }}</th>
                <th scope="col">{{ $t("emps.branch") }}</th>
                <th scope="col">{{ $t("emps.tax") }}</th>
                <th scope="col">{{ $t("emps.can_attend") }}</th>
                <th scope="col">{{ $t("emps.allawance") }}</th>
                <th scope="col">{{ $t("emps.pay_method") }}</th>
                <th scope="col">{{ $t("emps.employment_date") }}</th>
                <th scope="col">{{ $t("emps.birth_date") }}</th>
                <th scope="col">{{ $t("emps.tel") }}</th>
                <th scope="col">{{ $t("emps.degree") }}</th>
                <th scope="col">{{ $t("emps.has_social_insurance") }}</th>
                <th scope="col" v-for="col in configurations" :key="col">
                  {{
                    $i18n.locale == "ar"
                    ? col.name_ar
                      ? col.name_ar
                      : col.name
                    : col.name
                      ? col.name
                      : col.name_ar
                  }}
                </th>
                
                <th scope="col">{{ $t("emps.operations") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(app, index) in emps" :key="app" class="">
                <td>{{ ((this.page - 1) * 20) + index + 1 }}</td>
                <td>{{ app?.code }}</td>
                <td>{{ $i18n.locale == "en" ? app?.name : app?.arabic_name }}</td>
                <td>
                  <span>{{
                    $i18n.locale == "ar"
                    ? app?.title
                    : app?.title_en
                      ? app?.title_en
                      : app?.title
                  }}</span>
                </td>
                <td>
                  {{
                    $i18n.locale == "ar"
                    ? app?.branch_name
                    : app?.branch_name_en
                  }}
                </td>
                  <td>{{ app?.tax }}</td>

                <td>
                  <i v-if="app?.can_attend == 1" style="color: green" class="bx bx-check fa-2x"></i>
                  <i v-if="app?.can_attend == 0" style="color: red" class="bx bx-x fa-2x"></i>
                </td>
                <td v-if="app?.selected_allawance > 0">
                  <span>
                    {{
                      $i18n.locale == "ar"
                      ? `علاوة ${app.selected_allawance}`
                      : `Allawance Level ${app.selected_allawance}`
                    }}
                  </span>
                </td>
                <td v-if="app?.selected_allawance == 0">
                  <span>
                    {{
                      $i18n.locale == "ar" ? `الأجر الإبتدائي` : `Basic Salary`
                    }}
                  </span>
                </td>
                <td>
                  {{
                    $i18n.locale == "ar" ? app?.cash_name : app?.cash_name_en
                  }}
                </td>
                <td>{{ app?.employment_date?.split("T")[0] }}</td>
                <td>{{ app?.birth_date?.split("T")[0] }}</td>
                <td>{{ app?.tel }}</td>
                <td>{{ app?.degree }}</td>
                <td>

                  <i v-if="app?.has_social_insurance" style="color: green" class="bx bx-check fa-2x"></i>
                  <i v-if="!app?.has_social_insurance" style="color: red" class="bx bx-x fa-2x"></i>
                </td>
                <td v-for="col in configurations" :key="col">
                  {{ app[col.field] ? app[col.field] : "-" }}
                </td>
              
                <td>
                  <router-link class="text-white" :to="'/emps/profile/' + app?.id">
                    <button class="btn btn-primary" style="margin-inline-end: 4px">
                      {{ $t("popups.profile") }}
                    </button>
                  </router-link>
                  <button class="btn btn-primary" style="margin-inline-end: 4px" @click="editemp(app); edit_emp_modal.show()"
                    href="javascript: void(0);"  role="button">
                    {{ $t("popups.edit") }}
                  </button>
                  <button class="btn btn-danger" @click="deleteEmps(app)">
                    {{ $t("popups.delete") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="selectedTap">
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a class="page-link" href="javascript: void(0);" @click="get(page - 1)" aria-label="Previous">
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li class="page-item" :class="{ active: p == page }" v-for="p in tot_pages" :key="p">
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a class="page-link" href="javascript: void(0);" @click="get(page + 1)" aria-label="Next">
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- end  table -->
  <!-- Button trigger modal -->

  <!--   Apps  Pagination   -->
  <div class="row">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12" v-if="!selectedTap">
            <button class="btn-close text-" v-if="EmpsSearchMode" @click="cancelappsearchMode()"></button>
            <button type="button" class="btn btn-light float-end mb-4" data-bs-toggle="modal" data-bs-target="#add">
              <span class="bx bxs-plus-circle float-end fa-2x" style="color: #2a3042 !important"></span>
            </button>
            <button type="button" @click="selectedTap = !selectedTap" class="btn btn-light float-end mb-4">
              <span class="bx bxs-user float-start fa-2x" style="color: #2a3042 !important"></span>
            </button>
          </div>
        </div>

        <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table table-striped table-hover mb-0"
          v-if="!selectedTap">
          <thead>
            <tr class="text-light" style="background-color: #2a3042 !important">
              <th scope="col">{{ $t("config.id") }}</th>
              <th scope="col">{{ $t("config.ar") }}</th>
              <th scope="col">{{ $t("config.en") }}</th>

              <th scope="col">{{ $t("config.operations") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(config, index) in configurations" :key="config" class="">
              <td>{{ index + 1 }}</td>
              <td>{{ config.name_ar }}</td>
              <td>{{ config.name }}</td>

              <td>
                <a class="btn btn-primary me-2" @click="editconfigdata(config)" href="javascript: void(0);" role="button"
                  data-bs-toggle="modal" data-bs-target="#edit">{{ $t("popups.edit") }}</a>
                <a class="btn btn-danger me-2" href="javascript: void(0);" role="button" @click="deleteconfig(config)">{{
                  $t("popups.delete") }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!--  start add new col modal-->
  <div class="modal fade" id="add" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container px-0">
            <form @submit.prevent="addconfig()">
              <div class="modal-header">
                <h5 class="modal-title mt-3" id="exampleModalLabel">
                  {{ $t("popups.adacol") }}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  style="position: relative; left: 10px"></button>
              </div>
              <div class="mb-3 mt-4">
                <label for="exampleInputEmail1" class="form-label">{{$t('popups.name_ar')}}</label>
                <input type="text" v-model="data.ar" class="form-control" id="exampleInputEmail1"
                  aria-describedby="emailHelp" />
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">{{$t('popup.name_en')}}</label>
                <input type="text" v-model="data.en" class="form-control" id="exampleInputPassword1" />
              </div>
              <label for="exampleInputEmail1" class="form-label">Type</label>
              <select class="form-select" @change="onChange($event)" v-model="data.option"
                aria-label="Default select example">
                <option value="number">Number</option>
                <option value="text">Text</option>
                <option value="date">Date</option>
                <option value="select">Options</option>
              </select>
              <div v-if="this.option == 3">
                <button type="button" @click="addOptions.push({})" class="btn float-end">
                  <span class="bx bxs-plus-circle float-end fa-2x mb-2 mt-2" style="color: #2a3042 !important"></span>
                </button>
                <div v-for="option in addOptions" :key="option">
                  <input type="text" v-model="option.oneoption" class="form-control mb-2" id="exampleInputPassword1" />
                </div>
              </div>
              <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">
                  {{ $t("popups.add") }}
                </button>
                <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                  {{ $t("popups.cancel") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end add new col modal -->

  <!--start edit new col modal-->
  <div class="modal fade" id="edit" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container px-0">
            <form @submit.prevent="editconfig()">
              <div class="modal-header">
                <h5 class="modal-title mt-3" id="exampleModalLabel">
                  {{ $t("popups.adacol") }}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  style="position: relative; left: 10px"></button>
              </div>
              <div class="mb-3 mt-4">
                <label for="exampleInputEmail1" class="form-label">Arbic Name</label>
                <input type="text" v-model="editModalData.name_ar" class="form-control" id="exampleInputEmail1"
                  aria-describedby="emailHelp" />
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">English Name</label>
                <input type="text" v-model="editModalData.name" class="form-control" id="exampleInputPassword1" />
              </div>
              <label for="exampleInputEmail1" class="form-label">Type</label>
              <select class="form-select" @change="onChange($event)" v-model="editModalData.option"
                aria-label="Default select example">
                <option value="number">Number</option>
                <option value="text">text</option>
                <option value="date">Date</option>
                <option value="select">Options</option>
              </select>
              <div v-if="this.option == 3">
                <button type="button" @click="editOptions.push({})" class="btn float-end">
                  <span class="bx bxs-plus-circle float-end fa-2x mb-2 mt-2" style="color: #2a3042 !important"></span>
                </button>
                <div v-for="option in editOptions" :key="option">
                  <input type="text" v-model="option.oneoption" class="form-control mb-2" id="exampleInputPassword1" />
                </div>
              </div>
              <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">
                  {{ $t("popups.edit") }}
                </button>
                <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                  {{ $t("popups.cancel") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end edit new col modal-->


  <!--add emp-->
  <div class="modal fade" id="addemp" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container px-0">
            <form @submit.prevent="addEmps()">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {{ $t("popups.addemp") }}
                </h5>
              </div>


              <div class="row">
              <div class="col-6"></div>
              <div
                class="col-6"
                style="display: flex; justify-content: flex-end"
              ></div>
            </div>
            <div class="mt-3">
              <div class="progress-container">
                <div class="progress" id="progress"></div>
                <div class="circle active">1</div>
                <div class="circle">2</div>
                <div v-if="!project_based.has_salary" class="circle">3</div>
                <div class="circle">4</div>
              </div>
            </div>
            <div class="row stepper-content">
              <div class="col-12 col-md-12">
                <label for="exampleInputEmail1" class="form-label">
                  {{ $t("popups.designation") }}
                </label>
                <select class="form-select" aria-label="Default select example" required v-model="emp.emp_job_title_id" :class="{'p-active': tryNext && !emp.emp_job_title_id}">
                  <option v-for="i in emp_job" :key="i" :value="i.value">
                    {{
                      $i18n.locale == "ar"
                      ? i.lable
                      : i.lable_en
                        ? i.lable_en
                        : i.lable
                    }}
                  </option>
                </select>
                <small v-if="isFieldInvalid('emp_job_title_id')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>

              
              <!-- <div class="form-checkbox form-switch mb-3 ms-3">
                <input class="form-check-input" role="switch" type="checkbox"  v-model="emp.can_attend"
                   />
                <label for="exampleInputEmail1" class=" form-check-label mx-2">
                  {{ $t("emps.can_attend") }}
                </label>

              </div> -->

              <div class="my-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.allawance") }}
                </label>

                <select class="form-select" aria-label="Default select example" v-model="emp.selected_allawance">
                  <option v-for="allawance in allawanceLevels" :key="allawance" :value="allawance.value">
                    {{
                      $i18n.locale == "ar" ? allawance.name : allawance.name_en
                    }}
                  </option>
                </select>
                <small v-if="isFieldInvalid('selected_allawance')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.degree") }}
                </label>
                <select class="form-select" v-model="emp.degree" required aria-label="Default select example" :class="{'p-active': tryNext && !emp.degree}">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                </select>
                <small v-if="isFieldInvalid('degree')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
            </div>
            <div class="row stepper-content" style="display: none">
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("popups.name") }}
                </label>
                <input type="text" v-model="emp.name" class="form-control" required id="exampleInputPassword1"/>
                <small v-if="isFieldInvalid('name')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("popups.name_ar") }}
                </label>
                <input type="text" v-model="emp.name_ar" class="form-control" required id="exampleInputPassword1"/>
                <small v-if="isFieldInvalid('name_ar')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.birth_date") }}
                </label>
                <input type="date" v-model="emp.birth_date" class="form-control" required id="exampleInputPassword1"/>
                <small v-if="isFieldInvalid('birth_date')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.employment_date") }}
                </label>
                <input type="date" v-model="emp.employment_date" class="form-control" required id="exampleInputPassword1" />
                <small v-if="isFieldInvalid('employment_date')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("popups.telephone") }}
                </label>
                <input type="text" v-model="emp.tel" class="form-control" required id="exampleInputPassword1" />
              </div>
              <small v-if="isFieldInvalid('tel')" class="text-danger">
                {{ $t("hr_employees.required_field") }}
              </small>
            </div>
            <div class="row stepper-content" style="display: none">
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.tax") }}
                </label>
                <currency-input v-model="emp.tax" class="form-control" required id="exampleInputPassword1" />
                <small v-if="isFieldInvalid('tax')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>
              <div class="mb-3 mt-3">
                <div class="form-check d-flex gap-2 align-items-center mb-3">
                  <input type="checkbox" id="customCheck2" class="form-check-input" v-model="form.comboEnable" />
                   <label class="form-label  mt-2" for="customCheck2">
                     {{ $t('agents.enable_option') }}
                   </label>
                 </div>
                 <div v-if="form.comboEnable" class="mt-1">
                  <select
                    class="form-select mb-2"
                    v-model="form.selectedOption"
                    @change="handleSelectChange"
                  >
                    <option disabled value="">-- {{ $t('select') }} --</option>
                    <option value="loan">{{ $t('agents.loan') }}</option>
                    <option value="accrud">{{ $t('agents.accrud') }}</option>
                  </select>
                  <currency-input
                    class="form-control"
                    v-if="form.loan.enabled || form.accrud.enabled"
                     v-model.number="form[form.selectedOption].value"
                    :placeholder="$t('agents.amount')"
                    :min="0"
                  />
                  <currency-input v-else type="number" class="form-control"/>
                </div>
              </div>

              <div class="form-checkbox form-switch mb-3">
                <input class="form-check-input" role="switch" type="checkbox"   v-model="emp.has_social_insurance"
                   />
                <label for="exampleInputEmail1" class=" form-check-label mx-2">
                  {{ $t("emps.has_social_insurance") }}
                </label>
              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  {{ $t("emps.pay_method") }}
                </label>
                <select class="form-select" aria-label="Default select example" required v-model="emp.cash_account_id" :class="{'p-active': tryNext && !emp.cashAccounts}">
                  <option v-for="i in cashAccounts" :key="i" :value="i.cash_account_id">
                    {{ $i18n.locale == "ar" ? i?.name : i?.name_en }}
                  </option>
                </select>
                <small v-if="isFieldInvalid('cash_account_id')" class="text-danger">
                  {{ $t("hr_employees.required_field") }}
                </small>
              </div>

              <div class="mb-3" v-for="i in configurations" :key="i">
                <div v-if="i.type != 'select'">
                  <label for="exampleInputPassword1" class="form-label">{{
                    $i18n.locale == "ar"
                    ? i.name_ar
                      ? i.name_ar
                      : i.name
                    : i.name
                      ? i.name
                      : i.name_ar
                  }}
                  </label>
                  <input :type="i.type" v-model="i.extra" class="form-control" required id="exampleInputPassword1" />
                </div>

                <div v-else>
                  <label for="exampleInputPassword1" class="form-label">{{
                    $i18n.locale == "ar"
                    ? i.name_ar
                      ? i.name_ar
                      : i.name
                    : i.name
                      ? i.name
                      : i.name_ar
                  }}</label>
                  <select class="form-select" required aria-label="Default select example">
                    <option v-for="item in i.options" :key="item" :value="item.oneoption">
                      {{ item.oneoption }}
                    </option>
                  </select>
                </div>
              </div>

                <div class="mb-3">
                  <div class="d-flex justify-content-between">
                <label>{{ $t('emp_salary_items.selectsalaryitem') }}</label>
                <i class="bx bx-plus-medical fs-4" style="cursor: pointer;" @click="AddSalaryRow()"></i>
                </div>
                  <div class="mt-2">
                    <div v-for="(item, indx) in salaryForm" :key="indx" class="mb-3">
                      <div class="d-flex gap-2 justify-content-between">
                        <select class="form-select" v-model="item.selectedSalaryItem">
                          <option v-for="(itm, ind) in allsalaries" :key="ind" :value="itm" >
                            {{ $i18n.locale === 'ar' ? itm.name : itm.name_en }}
                          </option>
                        </select>
                      <div class="d-flex gap-2">
                        <currency-input v-model="item.value"  class="ms-5"/>
                        <i class="bx bx-x text-danger fs-3 align-items-center" style="cursor: pointer;" @click="this.salaryForm.splice(indx, 1)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--Schedual part-->
            <div class="row stepper-content" style="display: none">
                      <div class="row align-items-center">
                        <div class="mb-2">
                          <label for="scheduleType" class="block font-medium text-gray-700 me-2">
                            {{ $t("hr_employees.schedule_types.label") }}
                          </label>
                          <select
                            id="scheduleType"
                            v-model="selectedScheduleType"
                            class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
                          >
                            <option disabled value="">{{ $t("hr_employees.schedule_types.select_placeholder") }}</option>
                            <option v-for="type in hrWorkingScheduleTypes" :key="type" :value="type">
                              {{ $i18n.locale == "ar" ? type?.name : type.name_en }}
                            </option>
                          </select>
                        </div>
                        <!-- Choose if has attendance -->
                        <div class="col-12 col-md-12 pl-2 py-2" v-if="['weekly','work_rest_pattern', 'shift_based', 'monthly_days'].includes(selectedScheduleType.code)"
                        >
                          <label>{{ $t("hr_employees.has_attendance") }}</label>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :value="true"
                              v-model="emp.can_attend"
                              id=""
                            />
                            <label class="form-check-label" for="">
                              {{ $t("popups.yes") }}
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              :value="false"
                              v-model="emp.can_attend"
                              id=""
                            />
                            <label class="form-check-label" for="">
                              {{ $t("popups.no") }}
                            </label>
                          </div>
                        </div>
                        <!-- Weekly Schedule Config Display -->
                        <div
                          v-if="selectedScheduleType.code === 'weekly'"
                          class="card mb-4 shadow-sm border-success"
                        >
                          <div class="card-header text-white fw-bold" style="background-color: #163d87;">
                            {{ $t("hr_employees.shift.weekly_schedule_settings") }}
                          </div>

                          <div class="card-body">
                            <div class="row g-3">
                              <div class="col-md-6 col-lg-4">
                                <div class="border rounded p-3 bg-light h-100">
                                  <div class="text-muted fw-semibold mb-1">
                                    {{ $t("hr_employees.shift.week_start") }}
                                  </div>
                                  <div>{{ configu['Working Week Start Day'] }}</div>
                                </div>
                              </div>

                              <div class="col-md-6 col-lg-4">
                                <div class="border rounded p-3 bg-light h-100">
                                  <div class="text-muted fw-semibold mb-1">
                                    {{ $t("hr_employees.shift.week_end") }}
                                  </div>
                                  <div>{{ configu['Working Week End Day'] }}</div>
                                </div>
                              </div>

                              <div class="col-md-6 col-lg-4">
                                <div class="border rounded p-3 bg-light h-100">
                                  <div class="text-muted fw-semibold mb-1">
                                    {{ $t("hr_employees.shift.daily_start_time") }}
                                  </div>
                                  <div>{{ configu['Working Day Start Time'] }}</div>
                                </div>
                              </div>

                              <div class="col-md-6 col-lg-4">
                                <div class="border rounded p-3 bg-light h-100">
                                  <div class="text-muted fw-semibold mb-1">
                                    {{ $t("hr_employees.shift.daily_finish_time") }}
                                  </div>
                                  <div>{{ configu['Working Day Finish Time'] }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div
                          v-for="(day, index) in hr_weekdays"
                          :key="index"
                        >
                        <div
                          v-if="selectedScheduleType.code === 'shift_based'"
                          class="row align-items-center py-2 border-bottom"
                        >
                          <!-- Day Checkbox -->
                          <div class="col-md-4 d-flex align-items-center">
                            <input
                              :id="'day-' + index"
                              type="checkbox"
                              v-model="shiftData.weekdays[index].selected"
                              @change="
                                initializeDefaultTimes(index);
                                shiftData.weekdays[index].hr_weekday_id =
                                  day.id;
                              "
                              class="form-check-input m-2"
                            />
                            <label
                              :for="'day-' + index"
                              class="form-check-label"
                            >
                              {{
                                $i18n.locale === "en" ? day.name_en : day.name
                              }}
                            </label>
                          </div>

                          <!-- Time Inputs (conditionally shown) -->
                          <div
                            v-if="shiftData.weekdays[index]?.selected"
                            class="col-md-8 d-flex flex-wrap gap-3"
                          >
                          <div class="m-1 table-responsive">
                            <!-- Add Shift Button -->
                            <div class="col-12 d-flex justify-content-end mb-1">
                              <button
                                type="button"
                                class="btn btn-outline btn-sm"
                                @click="shiftData.weekdays[index].shifts.push({ start_time: '', end_time: '' })"
                              >
                              <span
                                class="bx bxs-plus-circle float-end fa-2x"
                                style="color: #2a3042 !important"
                              ></span>
                              </button>
                            </div>
                            <div
                              v-for="(shift, sIndex) in shiftData.weekdays[index].shifts"
                              :key="sIndex"
                              class="d-flex align-items-end mb-2 gap-2"
                            >
                              <div>
                                <label class="form-label">{{ $t("hr_employees.employee_profile.start_time") }}</label>
                                <input
                                  type="time"
                                  class="form-control"
                                  v-model="shift.start_time"
                                  required
                                />
                              </div>

                              <div>
                                <label class="form-label">{{ $t("hr_employees.employee_profile.end_time") }}</label>
                                <input
                                  type="time"
                                  class="form-control"
                                  v-model="shift.end_time"
                                  required
                                />
                              </div>

                              <div>
                                <button
                                  type="button"
                                  class="btn btn-danger"
                                  @click="shiftData.weekdays[index].shifts.splice(sIndex, 1)"
                                  :disabled="shiftData.weekdays[index].shifts.length <= 1"
                                >
                                  <i class="bx bx-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                        </div>
                        <!-- Work-Rest Pattern Inputs -->
                        <div v-if="selectedScheduleType.code === 'work_rest_pattern'" class="grid gap-4">
                          <!-- Top inputs for work and rest days -->
                          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="flex flex-col gap-1">
                              <label for="workDaysPerGroup" class="text-gray-700 font-medium">
                                {{ $t("hr_employees.schedule_types.work_days") }}
                              </label>
                              <input
                                id="workDaysPerGroup"
                                type="number"
                                min="1"
                                v-model.number="workDaysPerGroup"
                                class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200 m-1"
                              />
                            </div>
                            <div class="flex flex-col gap-1">
                              <label for="restDays" class="text-gray-700 font-medium">
                                {{ $t("hr_employees.schedule_types.rest_days") }}
                              </label>
                              <input
                                id="restDays"
                                type="number"
                                min="1"
                                v-model.number="restDays"
                                class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200 m-1"
                              />
                            </div>
                          </div>

                          <!-- Work Groups -->
                          <div
                            v-for="(group, groupIndex) in workGroups"
                            :key="groupIndex"
                            class="border p-4 rounded shadow mt-4"
                          >
                            <div class="flex justify-between items-center mb-2">
                              <h5 class="text-lg font-semibold">
                                {{ $t("hr_employees.schedule_types.work_group") }} {{ groupIndex + 1 }}
                              </h5>
                              <button class="btn btn-danger btn-sm" @click="deleteGroup(groupIndex)" v-if="workGroups.length > 1">
                                <i class="bx bx-trash"></i>
                              </button>
                            </div>

                            <div v-for="(shifts, dayIndex) in group.shifts" :key="dayIndex" class="mb-4 border rounded p-3">
                              <h6 class="text-md font-medium mb-2">
                                {{ $t("hr_employees.schedule_types.day") }} {{ dayIndex + 1 }}
                              </h6>

                              <div class="mb-3 text-end">
                                <button
                                  type="button"
                                  class="btn btn-outline btn-sm"
                                  @click="addShift(groupIndex, dayIndex)"
                                >
                                  <span class="bx bxs-plus-circle fa-2x" style="color: #2a3042 !important"></span>
                                </button>
                              </div>

                              <div v-for="(shift, shiftIndex) in shifts" :key="shiftIndex" class="d-flex gap-2 align-items-end mb-2 table-responsive">
                                <div>
                                  <label class="form-label">{{ $t("hr_employees.employee_profile.start_time") }}</label>
                                  <input type="time" class="form-control" v-model="shift.start_time" required />
                                </div>
                                <div>
                                  <label class="form-label">{{ $t("hr_employees.employee_profile.end_time") }}</label>
                                  <input type="time" class="form-control" v-model="shift.end_time" required />
                                </div>
                                <div>
                                  <button
                                    type="button"
                                    class="btn btn-danger"
                                    @click="removeShift(groupIndex, dayIndex, shiftIndex)"
                                    :disabled="shifts.length <= 1"
                                  >
                                    <i class="bx bx-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Add Group Button -->
                          <div class="mt-4">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              :disabled="!canAddMoreGroups"
                              @click="addWorkGroup"
                            >
                              {{ $t("hr_employees.schedule_types.add_next_group") }}
                            </button>
                          </div>

                          <!-- Total Day Summary -->
                          <div class="text-muted mt-3">
                            {{ $t("hr_employees.schedule_types.total_days_configured") }}: <strong>{{ totalDays }}</strong> / 31
                          </div>
                        </div>

                        <div v-if="selectedScheduleType.code === 'monthly_days'"
                          class="row align-items-center py-2 border-bottom">
                          <div
                            v-for="(dayItem, index) in shiftData.monthdays"
                            :key="index"
                          >
                            <!-- Checkbox + Label -->
                            <div class="col-md-4 d-flex align-items-center">
                              <input
                                type="checkbox"
                                :id="'month-day-' + index"
                                v-model="dayItem.selected"
                                class="form-check-input"
                              />
                              <label :for="'month-day-' + index" class="form-check-label ms-2">
                                {{ $t("hr_employees.schedule_types.day") }} {{ dayItem.hr_month_day_id }}
                              </label>
                            </div>

                            <!-- Start/End Time (if selected) -->
                            <div v-if="dayItem.selected" class="mt-2 table-responsive">
                              <div
                                v-for="(shift, sIndex) in shiftData.monthdays[index].shifts"
                                :key="sIndex"
                                class="d-flex align-items-end gap-2 mb-2"
                              >
                                <div class="flex-fill">
                                  <label class="form-label">{{ $t("hr_employees.employee_profile.start_time") }}</label>
                                  <input
                                    type="time"
                                    class="form-control"
                                    v-model="shift.start_time"
                                    required
                                  />
                                </div>

                                <div class="flex-fill">
                                  <label class="form-label">{{ $t("hr_employees.employee_profile.end_time") }}</label>
                                  <input
                                    type="time"
                                    class="form-control"
                                    v-model="shift.end_time"
                                    required
                                  />
                                </div>

                                <div class="d-flex align-items-center">
                                  <button
                                    type="button"
                                    class="btn btn-danger mt-4"
                                    @click="shiftData.monthdays[index].shifts.splice(sIndex, 1)"
                                    :disabled="shiftData.monthdays[index].shifts.length <= 1"
                                  >
                                    <i class="bx bx-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <hr>
                          </div>
                        </div>

                        <div v-if="selectedScheduleType.code === 'project_based'" class="row mb-3">
                          <div class="d-flex align-items-center">
                            <input
                              type="checkbox"
                              id="has_salary"
                              v-model="project_based.has_salary"
                              class="form-check-input"
                            />
                            <label for="has_salary" class="form-check-label ms-2">
                              {{ $t('hr_employees.schedule_types.include_salary') }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    

              <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
                <button
                  type="button"
                  class="stepper-btn btn-back"
                  id="prevBtn"
                  disabled
                >
                  {{ $t("popups.go_back") }}
                </button>
                <button type="button" class="stepper-btn btn-next" id="nextBtn">
                  {{ $t("popups.next") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary modal-btn btn-add"
                  id="submit"
                  style="display: none"
                >
                  {{ $t("popups.add") }}
                </button>
                <button
                  data-bs-dismiss="modal"
                  type="button"
                  class="btn btn-danger modal-btn"
                >
                  {{ $t("popups.cancel") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end add emp-->

  <!--edit emp-->
  <div class="modal fade" id="editemps" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container px-0">
            <form @submit.prevent="editEmps()">
              <div class="modal-header">
                <h5 class="modal-title mt-3" id="exampleModalLabel">
                  {{ $t("popups.edit") }}
                </h5>
              </div>

              <div class="mb-3 mt-4">
                <label for="exampleInputEmail1" class="form-label">
                  {{ $t("popups.designation") }}
                </label>
                <select class="form-select" aria-label="Default select example" v-model="edit.emp_job_title_id">
                  <option :selected="parseInt(edit.emp_job_title_id) == parseInt(i.value)
                    " v-for="i in emp_job" :key="i" :value="i.value">
                    {{
                      $i18n.locale == "ar"
                      ? i.lable
                      : i.lable_en
                        ? i.lable_en
                        : i.lable
                    }}
                  </option>
                </select>
              </div>

              <!-- <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.can_attend") }}
                </label>

                <select class="form-select" aria-label="Default select example" v-model="edit.can_attend">
                  <option value="1">{{ $t("popups.yes") }}</option>
                  <option value="0">{{ $t("popups.no") }}</option>
                </select>
              </div> -->
              <div class="form-checkbox form-switch mb-3">
                <input class="form-check-input" role="switch" type="checkbox"   v-model="edit.can_attend"
                   />
                <label for="exampleInputEmail1" class=" form-check-label mx-2">
                  {{ $t("emps.can_attend") }}
                </label>

              </div>
              
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.allawance") }}
                </label>

                <select class="form-select" aria-label="Default select example" v-model="edit.selected_allawance">
                  <option :selected="edit.selected_allawance == allawance.value" v-for="allawance in allawanceLevels"
                    :value="allawance.value" :key="allawance">
                    {{
                      $i18n.locale == "ar" ? allawance.name : allawance.name_en
                    }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("popups.name") }}
                </label>
                <input type="text" v-model="edit.name" class="form-control" id="exampleInputPassword1" />
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.employment_date") }}
                </label>
                <input type="date" v-model="edit.employment_date" class="form-control"  id="exampleInputPassword1" />
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.birth_date") }}
                </label>
                <input type="date" v-model="edit.birth_date" class="form-control" id="exampleInputPassword1" />
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("popups.telephone") }}
                </label>
                <input type="text" v-model="edit.tel" class="form-control" id="exampleInputPassword1" />
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.degree") }}
                </label>
                <select class="form-select" v-model="edit.degree" aria-label="Default select example">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="14">15</option>
                  <option value="14">16</option>
                  <option value="14">17</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">
                  {{ $t("emps.tax") }}
                </label>
                <input type="text" v-model="edit.tax" class="form-control" id="exampleInputPassword1" />
              </div>

              
                            <div class="form-checkbox form-switch mb-3">
                <input class="form-check-input" role="switch" type="checkbox"   v-model="edit.has_social_insurance"
                   />
                <label for="exampleInputEmail1" class=" form-check-label mx-2">
                  {{ $t("emps.has_social_insurance") }}
                </label>

              </div>

              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">
                  {{ $t("emps.pay_method") }}
                </label>
                <select required class="form-select" aria-label="Default select example" v-model="edit.cash_account_id">
                  <option v-for="i in cashAccounts" :key="i" :value="i.cash_account_id">
                    {{ $i18n.locale == "ar" ? i?.name : i?.name_en }}
                  </option>
                </select>
              </div>
              <br />
              <div class="mb-3" v-for="i in configurations" :key="i">
                <div v-if="i.type != 'select'">
                  <label for="exampleInputPassword1" class="form-label">{{
                    $i18n.locale == "ar"
                    ? i.name_ar
                      ? i.name_ar
                      : i.name
                    : i.name
                      ? i.name
                      : i.name_ar
                  }}</label>
                  <input :type="i.type" v-model="i.extra" class="form-control" id="exampleInputPassword1" />
                </div>

                <div v-else>
                  <label for="exampleInputPassword1" class="form-label">{{
                    i.name
                  }}</label>
                  <select class="form-select" aria-label="Default select example" v-model="i.edit">
                    <option v-for="item in i.options" :key="item" :value="item.oneoption">
                      {{ item.oneoption }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
                <button type="submit" class="btn btn-primary" >
                  {{ $t("popups.edit") }}
                </button>
                <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                  {{ $t("popups.cancel") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end edit emp-->
</template>
<style scoped>
/* .btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
} */

/* .add {
  position: relative;
  font-size: 12px;
  top: 25px;
  padding: 0px;
  margin: 0;
  margin-top: -22px;
  margin-top: -25px;
} */
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
.modal-content {
  z-index: -5;
}
.progress-container {
  display: flex;
  margin: 0 auto 30px;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 350px;
  max-width: 100%;
}
.progress-container::before {
  content: "";
  width: 100%;
  background-color: #f1f1f1;
  height: 5px;
  position: absolute;
  z-index: -1;
}
.progress {
  width: 0;
  background-color: #172c53;
  height: 5px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  z-index: -1;
  transition: 0.4s ease-in-out;
}
.circle {
  background: #fff;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #f1f1f1;
  border-radius: 50px;
}
.active {
  border-color: #0d47a1;
  transition: 0.6s ease-in;
}
.stepper-btn {
  border: none;
  padding: 5px 8px;
  width: 80px;
  font-size: 14px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  line-height: 1.5rem;
}
.btn-back {
    background: #172c53;
}
.btn-next {
    background: #1f53b2;
}
.btn-add {
    background: #163d87;
}
.modal-btn {
  padding: 5px 8px;
  width: 80px;
  font-size: 14px;
  border-radius: 5px;
}
.stepper-btn:disabled {
  background-color: #f1f1f1;
  cursor: not-allowed;
  color: #000;
}
.circle.no-salary {
  background-color: #f5c6cb;
  border-color: #dc3545;
}
</style>
